import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router";
import MainCard from "../../components/OB/MainCard";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";
import { formatTurkishToEnglishString } from "../../helpers/TodayDate";

const AnasayfaAraMenu = (props: any) => {
  const location = useLocation();
  const { menuList } = useContext(ConstantAPISContext); // Menü listesini contextten alıyoruz
  const [matchedMenu, setMatchedMenu] = useState<any>(null);

  useEffect(() => {
    if (menuList) {
      // Pathname'i alıyoruz ve formatlıyoruz
      const pathname = location.pathname.split("/"); // Başındaki / işaretini kaldırıyoruz
      console.log(pathname)
      const formattedPathname = formatTurkishToEnglishString(pathname[2]);

      // Menü listesi içerisinde arama yapıyoruz
      const foundMenu = menuList.find(item => 
        formatTurkishToEnglishString(item.ustBaslik.menuAdi).toLowerCase() === formattedPathname
      );

      setMatchedMenu(foundMenu);
      console.log("Foundeddddmenuuuu",foundMenu)
    }
    
  }, [location.pathname, menuList]);

  if (!menuList) {
    return <div>Menüler yükleniyor...</div>;
  }

  return matchedMenu ? (
    <div className="container-fluid">
      <div className="row">
        {matchedMenu.altBasliklar.map((item: any, number: any) => (
          <MainCard key={number} sqId={item.sqId} title={item.menuAdi} iconPath={item.ikonYolu} sayfaLink={item.sayfaLink} />
        ))}
      </div>
    </div>
  ) : (
    <div>Menüler yüklenirken hata oluştu lütfen tekrar deneyiniz.</div>
  );
};

export default AnasayfaAraMenu;
